<template>
  <div class="panel">
    <GroupHeader />
  </div>
</template>

<script>
import GroupHeader from '@/components/Group/GroupHeader.vue'
export default {
    components: {
        GroupHeader
    }
};
</script>

<style scoped>

</style>
